import { module } from 'modujs';

export default class GridHelper extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onKeyDownBind = this.onKeyDown.bind(this)
        this.onKeyUpBind = this.onKeyUp.bind(this)

        // UI
        this.$el = this.el
        this.$inner = this.$('inner')[0]

        // Data
        this.ctrlDown = false
        this.isActive = false
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.setColumns()
        this.bindEvents()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        document.addEventListener('keydown', this.onKeyDownBind)
        document.addEventListener('keyup', this.onKeyUpBind)
    }

    unbindEvents() {
        document.removeEventListener('keydown', this.onKeyDownBind)
        document.removeEventListener('keyup', this.onKeyUpBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onKeyDown(e) {
        if (e.key == 'Control') {
            this.ctrlDown = true
        } else {
            if (this.ctrlDown && e.key == 'g') {
                if (this.isActive) {
                    this.$el.classList.add('is-visible')
                } else {
                    this.$el.classList.remove('is-visible')
                }

                this.isActive = !this.isActive
            }
        }
    }

    onKeyUp(e) {
        if (e.key == 'Control') {
            this.ctrlDown = false
        }
    }

    ///////////////
    // Methods
    ///////////////
    setColumns() {
        // Clear columns
        this.$inner.innerHTML = ''

        // Loop through columns
        const columns = Number(window.getComputedStyle(this.$el).getPropertyValue('--grid-cols'))

        let $col
        for (var i = 0; i < columns; i++) {
            $col = document.createElement('div')
            this.$inner.appendChild($col)
        }
    }
}
